import { Outlet } from 'react-router-dom';

const MySpaceLayout = () => {
  return (
    <div className="flex flex-col">
      <Outlet />
    </div>
  );
};

export default MySpaceLayout;
